import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { MeasurementType } from "../../../viewer/measurement/types";

export type CalcContextType = {
  measurementType: MeasurementType;
  setMeasurementType: Dispatch<SetStateAction<MeasurementType>>;
  onEditingMode: boolean;
  setOnEditingMode: (value: boolean) => void;
};

export const CalcContext = createContext<CalcContextType>(
  {} as CalcContextType
);

export default CalcContext;

export const CalcContextProvider = (props: { children: ReactNode }) => {
  const [measurementType, setMeasurementType] = useState<MeasurementType>(null);
  const [onEditingMode, setOnEditingMode] = useState<boolean>(false);

  const contextValue = {
    measurementType,
    setMeasurementType,
    onEditingMode,
    setOnEditingMode,
  };

  return (
    <CalcContext.Provider value={contextValue}>
      {props.children}
    </CalcContext.Provider>
  );
};
